module.exports = __webpack_public_path__ + "img/project1.51a43d48.png";